import { cn } from "@nfp-tracker/utils";
import { PropsWithChildren } from "react";

type SafeAreaProps = PropsWithChildren<{
  className?: string;
  contentClassName?: string;
}>;

const SafeArea = ({ children, className, contentClassName }: SafeAreaProps) => {
  const containerClasses = ["safe-area", className].filter(Boolean).join(" ");
  const contentClasses = ["safe-area__content", contentClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses} role="main">
      <div className="safe-area__bg" aria-hidden="true" />
      <div className={cn(contentClasses)}>
        {children}
      </div>
    </div>
  );
};

export default SafeArea;
